import React from 'react'
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'

import { useAuthIsAuthenticated } from '@/entities/auth'

export const Route = createFileRoute('/_auth')({
    component: RouteComponent,
})

function RouteComponent() {
    const { isAuthenticated } = useAuthIsAuthenticated()

    if (isAuthenticated) {
        return <Navigate search={{ page: 1 }} to='/recruitment' />
    }

    return <Outlet />
}
